import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class TopSearchService {
  private baseUrl = 'search/top-bar';

  constructor(private http: HttpClient) {}

  search(query: string, page: number = 1, limit: number = 10): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl, {
      params: {
        q: query,
        page,
        limit
      }
    });
  }
}